
import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import PrivacyContent from './components/PrivacyContent';

export default function PrivacyPage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar forceWhiteBg={true} />
        <PrivacyContent />
        <Footer />
        <FloatingCTA />
      </div>
    </Suspense>
  );
}
